import Swiper from "swiper/bundle";

// Accordion item block.
document.addEventListener("DOMContentLoaded", function () {
  var accItems = document.querySelectorAll(".accordion-item");

  function toggleAccordion(header) {
    var item = header.parentNode;
    var content = header.nextElementSibling;

    // Toggle the current accordion
    item.classList.toggle("open");
    content.style.maxHeight = item.classList.contains("open")
      ? content.scrollHeight + "px"
      : null;
  }

  // Function to close all accordion items
  function closeAllAccordions(except = null) {
    accItems.forEach(function (item) {
      if (item !== except) {
        item.classList.remove("open");
        var content = item.querySelector(".accordion-content");
        content.style.maxHeight = null;
      }
    });
  }

  // Attach click event listeners to each accordion header
  accItems.forEach(function (item) {
    item
      .querySelector(".accordion-header")
      .addEventListener("click", function () {
        closeAllAccordions(item);
        toggleAccordion(this);
      });
  });

  // Open the accordion items marked for opening on load
  accItems.forEach(function (item) {
    if (item.classList.contains("open-on-load")) {
      item.classList.add("open");
      var content = item.querySelector(".accordion-content");
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
});

// Function to check if element is in viewport
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// Function to animate digits
function animateDigits(element, delay) {
  setTimeout(() => {
    // Extract the full initial text, including any +, -, or % characters
    const fullText = element.getAttribute("data-final-text");
    // Use a regex to extract just the numeric part for animation
    const numberMatch = fullText.match(/-?\d+/);
    const end = numberMatch ? parseInt(numberMatch[0], 10) : 0;
    const start = 0;
    const duration = 1000;
    const startTime = performance.now();

    function step(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const currentNumber = Math.round(start + (end - start) * progress);
      // Update the element's text content, preserving the original characters
      element.textContent = fullText.replace(/-?\d+/, currentNumber);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  }, delay);
}

// Function to handle scroll event
function handleScroll() {
  const elements = document.querySelectorAll(".animate-nr");
  elements.forEach((element, index) => {
    if (isInViewport(element) && !element.classList.contains("animated")) {
      element.classList.add("animated");
      const delay = index * 0; // 200ms delay per block
      animateDigits(element, delay);
    }
  });
}

// Initialize elements with final numbers and set their text content to 0, preserving +, -, or %
function initializeAnimationTargets() {
  const elements = document.querySelectorAll(".animate-nr");
  elements.forEach((element) => {
    const fullText = element.textContent;
    // Set the full original text as an attribute for later use
    element.setAttribute("data-final-text", fullText);
    // Use regex to find numbers, ensuring at least one match is found, otherwise default to "0"
    const matches = fullText.match(/-?\d+/);
    const initialNumber = matches && matches.length > 0 ? matches[0] : "0";
    // Replace the numeric part in the original text with "0" for the initial state
    element.textContent = fullText.replace(/-?\d+/, "0");
  });
}

// Add event listener for scroll event
window.addEventListener("scroll", handleScroll);

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    // Add a slight delay to allow the layout to stabilize
    initializeAnimationTargets();
    handleScroll(); // Check if elements are in viewport initially
  }, 100); // 100 milliseconds delay should be enough
});

document.addEventListener("DOMContentLoaded", () => {
  // Smooth scroll for anchor links.
  // Select all anchor links with a hash (#) prefix.
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    // Add a click event listener to each anchor link.
    anchor.addEventListener("click", function (e) {
      e.preventDefault();

      // Get the target element ID from the anchor's href attribute.
      const targetId = this.getAttribute("href");
      const targetElement = document.querySelector(targetId);

      // Check if the target element exists.
      if (targetElement) {
        // Scroll to the target element.
        setTimeout(function () {
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        });
      }
    });
  });
});

window.onload = function () {
  // Testimonial swiper.
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
    },
    autoHeight: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: true,
    },
  });

  // Logo swiper.
  let SwiperTop = new Swiper(".swiper-container", {
    spaceBetween: 30,
    centeredSlides: true,
    slidesPerView: "auto",
    speed: 6000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    allowTouchMove: false,
    disableOnInteraction: true,
  });

  // Nav Logo swiper.
  let sviper = new Swiper(".logoswipe", {
    direction: "vertical",
    spaceBetween: 15,
    centeredSlides: true,
    speed: 5000,
    autoplay: {
      delay: 1,
      reverseDirection: true,
    },
    loop: true,
    slidesPerView: "auto",
    allowTouchMove: false,
    disableOnInteraction: true,
  });
};

// Function to create the overlay div.
function createOverlay() {
  var overlay = document.createElement("div");
  overlay.id = "overlay";
  overlay.className = "overlay";
  document.body.appendChild(overlay);
  return overlay;
}
var overlay = createOverlay();

// Add a click event listener to the hamburger button.
const hamburgerButtonArea = document.getElementById("nav-toggle");
const hamburgerButton = document.getElementById("burger-icon");
hamburgerButtonArea.addEventListener("click", function () {
  document.body.classList.toggle("nav-open");
  hamburgerButton.classList.toggle("open");
});

// Add a click event listener to the overlay to close the navigation.
overlay.addEventListener("click", function () {
  document.body.classList.remove("nav-open");
  hamburgerButton.classList.remove("open");
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".trippleSwiper").forEach((el) => {
    new Swiper(el, {
      slidesPerView: 3,
      spaceBetween: 30,
      pagination: false,
      loop: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      centeredSlides: false,
      autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  });
});

// Define a throttle function
function throttle(func, limit) {
  // Variable to keep track of whether the function is currently throttled
  let inThrottle;

  // Return a new function that wraps the original function
  return function () {
    // Save the arguments and context for later use
    const args = arguments;
    const context = this;

    // If the function is not currently throttled, execute it
    if (!inThrottle) {
      func.apply(context, args);
      // Set the throttle flag to true
      inThrottle = true;
      // After the limit period, reset the throttle flag
      setTimeout(() => (inThrottle = false), limit);
    }
  };
}

document.addEventListener("DOMContentLoaded", function () {
  var lastScrollTop = 0;
  var headerHideThreshold = 400;
  var header = document.getElementById("main-header");
  var adminBar = document.getElementById("wpadminbar");
  var adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
  var callout = document.getElementById("site-global-callout"); // Reference to the callout
  var calloutHeight = callout ? callout.offsetHeight : 0; // Height of the callout
  header.classList.add("at-top");
  header.style.top = adminBarHeight + "px";

  window.addEventListener(
    "scroll",
    function () {
      var currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;
      var isAtTop = currentScroll <= 100;

      if (isAtTop) {
        header.classList.add("at-top");
      } else {
        header.classList.remove("at-top");
      }

      var isBottomOfPage =
        Math.ceil(window.scrollY) >=
        document.body.scrollHeight - window.innerHeight;

      // Adjust the headerHideThreshold by adding the callout height
      var adjustedHeaderHideThreshold = headerHideThreshold + calloutHeight;

      // Use the adjusted threshold in the condition to hide the header
      if (
        currentScroll > lastScrollTop &&
        currentScroll > adjustedHeaderHideThreshold &&
        !isBottomOfPage
      ) {
        header.style.top =
          "-" + (header.offsetHeight + adminBarHeight + calloutHeight) + "px";
      } else if (currentScroll < lastScrollTop || isBottomOfPage) {
        header.style.top = adminBarHeight + "px";
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    },
    false
  );
});

document.addEventListener("DOMContentLoaded", function () {
  var modal = document.getElementById("modal-book");
  var body = document.body;

  // Open modal when a link with '#openmodal' is clicked
  document.querySelectorAll('a[href="#openmodal"]').forEach(function (link) {
    link.addEventListener("click", function (event) {
      console.log("clasidasdsa");
      event.preventDefault(); // Prevent default anchor behavior
      modal.style.display = "flex";
      body.classList.add("modal-open");
      console.log("open modal");
    });
  });

  var span = document.getElementsByClassName("close-modal")[0];

  span.onclick = function () {
    console.log("close modal");
    modal.style.display = "none";
    body.classList.remove("modal-open");
  };

  window.onclick = function (event) {
    if (event.target == modal) {
      console.log("close modal");
      modal.style.display = "none";
      body.classList.remove("modal-open");
    }
  };
});

// Adding a class to the sub-menu items that have no grandchildren,
// this way we can target them with CSS and ensure they are displayed correctly. (vertically)
document
  .querySelectorAll(".nav-center > li > .sub-menu")
  .forEach(function (subMenu) {
    const hasGrandchildren = subMenu.querySelector(".sub-menu") !== null;
    const hasPromoItem =
      subMenu.querySelector("li.menu-item-promotion") !== null;

    if (!hasGrandchildren && hasPromoItem) {
      subMenu.classList.add("no-grandchildren-has-promo");
    } else if (!hasGrandchildren) {
      subMenu.classList.add("no-grandchildren");
    } else if (hasGrandchildren) {
      subMenu.classList.add("has-grandchildren");
    }
  });

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".sub-menu.no-grandchildren-has-promo")
    .forEach(function (subMenu) {
      // Create a new div to wrap the regular items
      var container = document.createElement("div");
      container.classList.add("submenu-items-container");

      // Get all 'li's that are not the promo item
      var regularItems = subMenu.querySelectorAll(
        "li:not(.menu-item-promotion)"
      );

      regularItems.forEach(function (item) {
        container.appendChild(item);
      });

      // Insert the container at the beginning of the submenu
      subMenu.insertBefore(
        container,
        subMenu.querySelector("li.menu-item-promotion")
      );
    });
});

/**
 * Accordion navs for mobile >
 */
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) {
    initMobileSubmenus();
  }
});

function initMobileSubmenus() {
  const menuItems = document.querySelectorAll(
    ".mob-nav .menu-item-has-children"
  );

  function toggleSubmenu(menuItem) {
    const submenu = menuItem.querySelector(".sub-menu");
    const isExpanded = menuItem.classList.contains("submenu-expanded");
    const duration = 300; // Control speed here!

    // Clear any existing timeout
    if (submenu.animationTimeout) {
      clearTimeout(submenu.animationTimeout);
    }

    if (isExpanded) {
      // Collapse
      menuItem.classList.remove("submenu-expanded");
      submenu.style.transition = `height ${duration}ms ease-in-out`;

      // Set current height explicitly first (in case it was 'auto')
      if (submenu.style.height === "auto" || !submenu.style.height) {
        submenu.style.height = submenu.scrollHeight + "px";
        submenu.offsetHeight; // Force reflow
      }

      submenu.style.height = "0px";
    } else {
      // Expand
      menuItem.classList.add("submenu-expanded");
      submenu.style.transition = `height ${duration}ms ease-in-out`;
      submenu.style.height = submenu.scrollHeight + "px";

      // Set to auto after animation
      submenu.animationTimeout = setTimeout(() => {
        submenu.style.height = "auto";
      }, duration);
    }
  }

  // Attach click event listeners
  menuItems.forEach(function (item) {
    const link = item.querySelector("a");
    const submenu = item.querySelector(".sub-menu");

    if (link && submenu) {
      // Initialize timeout storage
      submenu.animationTimeout = null;

      // Open if current page is in submenu (no animation)
      if (isCurrentPageInSubmenu(submenu)) {
        item.classList.add("submenu-expanded");
        submenu.style.height = "auto";
      }

      // Add click handler
      link.addEventListener("click", function (e) {
        const rect = link.getBoundingClientRect();
        const clickX = e.clientX;
        const rightEdge = rect.right;

        if (clickX > rightEdge - 70) {
          e.preventDefault();
          toggleSubmenu(item);
        }
      });
    }
  });
}

function isCurrentPageInSubmenu(submenu) {
  const currentUrl = window.location.href;
  const submenuLinks = submenu.querySelectorAll("a");

  for (let link of submenuLinks) {
    if (link.href === currentUrl) {
      return true;
    }
  }
  return false;
}
/**
 * Accordion navs for mobile <
 */

// document.addEventListener('DOMContentLoaded', () => {
//     const scrollers = document.querySelectorAll('.logo-scroller');

//     scrollers.forEach((scroller) => {
//       const containers = scroller.querySelectorAll('.logo-container');

//       let container1, container2;

//       if (containers.length < 2) {
//         // Clone the first container to create a seamless loop
//         container1 = containers[0];
//         container2 = container1.cloneNode(true);
//         scroller.appendChild(container2);
//       } else {
//         container1 = containers[0];
//         container2 = containers[1];
//       }

//       // Ensure container2 has the same content as container1
//       container2.innerHTML = container1.innerHTML;

//       // Calculate total height of the scrolling content
//       const contentHeight = container1.offsetHeight;

//       // Desired scrolling speed in pixels per second
//       const speed = 30; // Adjust this value to set the scrolling speed

//       // Calculate animation duration
//       const duration = contentHeight / speed;

//       // Generate a unique keyframe name for each scroller to prevent conflicts
//       const keyframeName = `scrollUp${Math.random().toString(36).substr(2, 9)}`;

//       // Inject keyframes into the document's stylesheet
//       const styleSheet = document.styleSheets[0];
//       styleSheet.insertRule(`
//         @keyframes ${keyframeName} {
//           0% {
//             transform: translateY(0);
//           }
//           100% {
//             transform: translateY(-${contentHeight}px);
//           }
//         }
//       `, styleSheet.cssRules.length);

//       // Apply animation to the containers
//       container1.style.animation = `${keyframeName} ${duration}s linear infinite`;
//       container2.style.animation = `${keyframeName} ${duration}s linear infinite`;

//       // Position the containers for seamless scrolling
//       container1.style.position = 'absolute';
//       container1.style.top = '0';
//       container2.style.position = 'absolute';
//       container2.style.top = `${contentHeight}px`;

//     //   // Optional: Pause on hover
//     //   scroller.addEventListener('mouseenter', () => {
//     //     container1.style.animationPlayState = 'paused';
//     //     container2.style.animationPlayState = 'paused';
//     //   });

//     //   scroller.addEventListener('mouseleave', () => {
//     //     container1.style.animationPlayState = 'running';
//     //     container2.style.animationPlayState = 'running';
//     //   });
//     });
//   });

// function setupLogoScroller(scrollerElement) {
//     const container = scrollerElement.querySelector('.logo-container');
//     const originalLogos = container.innerHTML;

//     // Create two sets of logos
//     container.innerHTML = originalLogos + originalLogos;

//     const logoSetHeight = container.scrollHeight / 2;
//     let scrollPosition = 0;
//     let scrollSpeed = 0.4; // Initial scroll speed
//     const maxScrollSpeed = 0.4; // Maximum scroll speed
//     let targetSpeed = maxScrollSpeed;

//     function scroll(currentTime) {
//         scrollSpeed += (targetSpeed - scrollSpeed) * 0.05; // Smooth speed transition
//         scrollPosition += scrollSpeed;

//         if (scrollPosition >= logoSetHeight) {
//             scrollPosition = 0;
//         }

//         container.style.transform = `translateY(-${scrollPosition}px)`;

//         requestAnimationFrame(scroll);
//     }

//     scrollerElement.addEventListener('mouseenter', () => {
//         targetSpeed = 0;
//     });

//     scrollerElement.addEventListener('mouseleave', () => {
//         targetSpeed = maxScrollSpeed;
//     });

//     requestAnimationFrame(scroll);
// }

// // Run the setup for all logo scrollers when the page loads
// window.addEventListener('load', () => {
//     const scrollers = document.querySelectorAll('.logo-scroller');
//     scrollers.forEach(scroller => setupLogoScroller(scroller));
// });

// // Rerun setup for all scrollers if window is resized
// window.addEventListener('resize', () => {
//     const scrollers = document.querySelectorAll('.logo-scroller');
//     scrollers.forEach(scroller => setupLogoScroller(scroller));
// });

function setupLogoScroller(scrollerElement) {
  const container = scrollerElement.querySelector(".logo-container");

  // Cleanup: Reset container's content to the original logos
  const originalLogos =
    scrollerElement.dataset.originalLogos || container.innerHTML;
  scrollerElement.dataset.originalLogos = originalLogos; // Save original logos if not already saved
  container.innerHTML = originalLogos + originalLogos;

  const logoSetHeight = container.scrollHeight / 2;
  let scrollPosition = 0;
  let scrollSpeed = 0.4; // Initial scroll speed
  const maxScrollSpeed = 0.4; // Maximum scroll speed
  let targetSpeed = maxScrollSpeed;

  let animationFrame;

  function scroll() {
    scrollSpeed += (targetSpeed - scrollSpeed) * 0.05; // Smooth speed transition
    scrollPosition += scrollSpeed;

    if (scrollPosition >= logoSetHeight) {
      scrollPosition = 0;
    }

    container.style.transform = `translateY(-${scrollPosition}px)`;

    animationFrame = requestAnimationFrame(scroll);
  }

  function stopScroll() {
    cancelAnimationFrame(animationFrame);
  }

  scrollerElement.addEventListener("mouseenter", () => {
    targetSpeed = 0;
  });

  scrollerElement.addEventListener("mouseleave", () => {
    targetSpeed = maxScrollSpeed;
  });

  // Start the animation
  scroll();

  // Attach cleanup to the scroller for reuse on resize
  scrollerElement._stopScroll = stopScroll;
}

// Initialize all logo scrollers
function initializeLogoScrollers() {
  const scrollers = document.querySelectorAll(".logo-scroller");

  scrollers.forEach((scroller) => {
    // Cleanup any existing scroller
    if (scroller._stopScroll) {
      scroller._stopScroll();
    }

    // Setup the scroller
    setupLogoScroller(scroller);
  });
}

// Run the setup when the page loads
window.addEventListener("load", initializeLogoScrollers);

// Rerun setup for all scrollers on window resize
window.addEventListener("resize", initializeLogoScrollers);

// ENHANCED LIVE SEARCH SYSTEM - SIMPLIFIED VERSION
document.addEventListener("DOMContentLoaded", function () {
  // ============================================================================
  // STATE MANAGEMENT
  // ============================================================================

  let searchTimeout;
  let activeRequest = null;
  let lastSearchTerm = "";
  let cachedResults = new Map();

  // ============================================================================
  // UTILITY FUNCTIONS
  // ============================================================================

  /**
   * Generates a unique cache key for search results
   * Normalizes search term to lowercase and trims whitespace for better cache hits
   */
  const getCacheKey = (container, searchTerm) => {
    const form = container.querySelector(".custom-search-form");

    const postTypes = Array.from(form.querySelectorAll(".js-post-type"))
      .map((input) => input.dataset.value)
      .sort()
      .join(",");

    const taxonomies = Array.from(form.querySelectorAll(".js-taxonomy"))
      .map((input) => input.dataset.value)
      .sort()
      .join(",");

    // Normalize search term: lowercase and trim whitespace
    const normalizedSearchTerm = searchTerm.toLowerCase().trim();

    return `${normalizedSearchTerm}|${postTypes}|${taxonomies}`;
  };

  /**
   * Shows/hides search results with consistent behavior
   */
  const toggleResults = (container, show = true) => {
    container.style.display = show ? "block" : "none";
  };

  /**
   * Displays cached or existing results if available
   * Uses normalized search terms for better cache matching
   */
  const showCachedResults = (container, searchTerm) => {
    const resultsContainer = container.querySelector(
      ".live-search-results-container"
    );

    if (searchTerm.length < 2) return false;

    const cacheKey = getCacheKey(container, searchTerm); // This now uses normalized term

    // First priority: cached results
    if (cachedResults.has(cacheKey)) {
      resultsContainer.innerHTML = cachedResults.get(cacheKey);
      toggleResults(resultsContainer, true);
      return true;
    }

    // Second priority: existing results that match current search
    // Normalize both terms for comparison
    const normalizedCurrent = searchTerm.toLowerCase().trim();
    const normalizedLast = lastSearchTerm.toLowerCase().trim();

    if (
      normalizedCurrent === normalizedLast &&
      resultsContainer.innerHTML.trim() !== ""
    ) {
      toggleResults(resultsContainer, true);
      return true;
    }

    return false;
  };

  // ============================================================================
  // MAIN SEARCH FUNCTION
  // ============================================================================

  /**
   * Performs the actual AJAX search request using modern fetch() API
   */
  async function performLiveSearch(container, searchTerm) {
    const form = container.querySelector(".custom-search-form");
    const resultsContainer = container.querySelector(
      ".live-search-results-container"
    );

    // Extract search configuration
    const postTypes = Array.from(form.querySelectorAll(".js-post-type")).map(
      (input) => input.dataset.value
    );
    const taxonomies = Array.from(form.querySelectorAll(".js-taxonomy")).map(
      (input) => input.dataset.value
    );

    // Prepare FormData
    const formData = new FormData();
    formData.append("action", "custom_live_search");
    formData.append("search_term", searchTerm);
    formData.append("nonce", customSearch.nonce);

    postTypes.forEach((type) => formData.append("post_types[]", type));
    taxonomies.forEach((tax) => formData.append("taxonomies[]", tax));

    try {
      // Create AbortController for request cancellation
      const controller = new AbortController();
      activeRequest = controller;

      const response = await fetch(customSearch.ajaxurl, {
        method: "POST",
        body: formData,
        signal: controller.signal,
      });

      container.classList.remove("searching");

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseText = await response.text();
      resultsContainer.innerHTML = responseText;
      toggleResults(resultsContainer, true);

      // Cache management
      const cacheKey = getCacheKey(container, searchTerm);
      cachedResults.set(cacheKey, responseText);

      // Memory management - limit cache size
      if (cachedResults.size > 20) {
        const firstKey = cachedResults.keys().next().value;
        cachedResults.delete(firstKey);
      }

      lastSearchTerm = searchTerm.toLowerCase().trim();
    } catch (error) {
      container.classList.remove("searching");

      if (error.name === "AbortError") return;

      const errorMessage =
        '<div class="search-error">Search error occurred. Please try again.</div>';
      resultsContainer.innerHTML = errorMessage;
      toggleResults(resultsContainer, true);

      console.error("Search error:", error);
    } finally {
      activeRequest = null;
    }
  }

  // ============================================================================
  // EVENT HANDLERS
  // ============================================================================

  /**
   * Unified input/focus/click handler for search inputs
   */
  const handleSearchInput = (e, isTyping = false) => {
    if (!e.target.classList.contains("custom-search-input")) return;

    const input = e.target;
    const container = input.closest(".custom-search-container");
    const searchTerm = input.value.trim();

    // Cancel any pending operations
    clearTimeout(searchTimeout);
    if (activeRequest) {
      activeRequest.abort();
      activeRequest = null;
    }

    // Handle short search terms
    if (searchTerm.length < 2) {
      const resultsContainer = container.querySelector(
        ".live-search-results-container"
      );
      toggleResults(resultsContainer, false);
      container.classList.remove("searching");
      lastSearchTerm = "";
      return;
    }

    // Try to show cached results first
    if (showCachedResults(container, searchTerm)) {
      return;
    }

    // Only perform new search if user is typing
    if (isTyping) {
      container.classList.add("searching");

      // Debounce the search
      searchTimeout = setTimeout(() => {
        performLiveSearch(container, searchTerm);
      }, 300);
    }
  };

  // ============================================================================
  // EVENT LISTENERS
  // ============================================================================

  // Input handler with debouncing
  document.addEventListener("input", (e) => handleSearchInput(e, true));

  // Focus and click handlers (no debouncing needed)
  document.addEventListener("focus", (e) => handleSearchInput(e, false), true);
  document.addEventListener("click", (e) => handleSearchInput(e, false));

  // Outside click handler - hide all results
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".custom-search-container")) {
      document
        .querySelectorAll(".live-search-results-container")
        .forEach((container) => toggleResults(container, false));
    }
  });

  // ESC key handler
  document.addEventListener("keydown", function (e) {
    if (
      e.key === "Escape" &&
      e.target.classList.contains("custom-search-input")
    ) {
      const container = e.target.closest(".custom-search-container");
      const resultsContainer = container.querySelector(
        ".live-search-results-container"
      );
      toggleResults(resultsContainer, false);
      container.classList.remove("searching");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function initializeMobileSliders() {
    const sliderElements = document.querySelectorAll(
      '[data-mobile-slider="true"]'
    );

    sliderElements.forEach((element) => {
      // Skip if already initialized or not on mobile
      if (element.swiper || window.innerWidth > 640) return;

      // Get settings from data attributes
      const slidesPerView = parseInt(element.dataset.slidesPerView) || 1;

      // Set up Swiper structure
      element.classList.add("swiper-wrapper");

      Array.from(element.children).forEach((li) => {
        li.classList.add("swiper-slide");
      });

      // Create parent wrapper
      const swiperContainer = document.createElement("div");
      swiperContainer.className = "swiper";
      element.parentNode.insertBefore(swiperContainer, element);
      swiperContainer.appendChild(element);

      // Add pagination
      const pagination = document.createElement("div");
      pagination.className = "swiper-pagination";
      swiperContainer.appendChild(pagination);

      // Initialize Swiper with block-specific settings
      new Swiper(swiperContainer, {
        slidesPerView: slidesPerView,
        spaceBetween: 16,
        grabCursor: true,
        a11y: {
          enabled: true,
          prevSlideMessage: "Previous slide",
          nextSlideMessage: "Next slide",
          paginationBulletMessage: "Go to slide {{index}}",
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        keyboard: {
          enabled: true,
        },
      });

      // Add region label to container
      swiperContainer.setAttribute("role", "region");
      swiperContainer.setAttribute("aria-label", "Content slider");
    });
  }

  initializeMobileSliders();
});
